import React, { useState, useEffect } from 'react';
// Services
import { getStaticText } from '../../lables/lablesService';
import usersApi from '../UsersPage/api/usersService';
import subscribersService from '../Subscribers/api/subscribersApi';
import newsCategories from '../News/api/newsCategories';
import newsRecords from '../News/api/newsRecords';
import AboutUsCategories from '../AboutUs/api/about-us-categories';
import AboutUsPosts from '../AboutUs/api/about-us-posts'
import VacancyCategories from '../Vacancies/api/vacancyCategories';
import VacancyPosts from '../Vacancies/api/vacancyPosts';
import TransportationToOrderCategories from '../TransportationToOrder/api/transportationToOrderCategories';
import TransportationToOrderPosts from '../TransportationToOrder/api/transportationToOrderPosts';
import RoadToAirportCategories from '../RoadToAirport/api/categories';
import RoadToAirportPosts from '../RoadToAirport/api/posts';
import InformationForTouristsCategories from '../InformationForTourists/api/categories';
import InformationForTouristsPosts from '../InformationForTourists/api/posts';
import InternationalProjectsCategories from '../InternationalProjects/api/categories';
import InternationalProjectsPosts from '../InternationalProjects/api/posts';
import ElectricitySupplyCategories from '../ElectricitySupply/api/categories';
import ElectricitySupplyPosts from '../ElectricitySupply/api/posts';
import RoadSituationCategories from '../RoadSituation/api/categories';
import RoadSituationPosts from '../RoadSituation/api/posts';
import driversSchoolApi from '../DriversSchoolPage/api/driversSchool';
import driversSchoolCategoriesApi from '../DriversSchoolPage/api/driversSchoolCategories';
import apiLanguageMethodService from '../LanguagePage/api/apiLanguages';
import TicketsCategories from '../Ticket/api/categories';
import TicketsPosts from '../Ticket/api/posts';

//Components
import PageCard from './PageCard';
import Spinner from '../../components/spinner-component/Spinner';
import DashboardWrapper, { DashboardWrapperMain } from '../../components/dashboard-wrapper/DashboardWrapper';

/**
 * Parent page component
 * 
 * @returns JSX
 */
const Dashboard = () => {
    //State for loading data
    const [loading, setLoading] = useState(true);
    //States for det all data list
    const [users_length, setUser_Length] = useState([]);
    const [subscribers_length, setSubscribers_Length] = useState([]);
    const [nc_length, setNC_Length] = useState([]);
    const [nr_length, setNR_Length] = useState([]);
    const [iac_length, setIAC_Lenght] = useState([]);
    const [iar_length, setIAR_Lenght] = useState([]);
    const [vc_length, setVC_Lenght] = useState([]);
    const [vr_length, setVR_Lenght] = useState([]);
    const [ttoc_length, setTTOC_Lenght] = useState([]);
    const [ttor_length, setTTOR_Lenght] = useState([]);
    const [rtac_length, setRTAC_Lenght] = useState([]);
    const [rtar_length, setRTAR_Lenght] = useState([]);
    const [iftc_length, setIFTC_Lenght] = useState([]);
    const [iftr_length, setIFTR_Lenght] = useState([]);
    const [ipc_length, setIPC_Lenght] = useState([]);
    const [ipr_length, setIPR_Lenght] = useState([]);
    const [esc_length, setESC_Lenght] = useState([]);
    const [esr_length, setESR_Lenght] = useState([]);
    const [rsc_length, setRSC_Lenght] = useState([]);
    const [rsr_length, setRSR_Lenght] = useState([]);
    const [tc_length, setTC_length] = useState([]);
    const [tr_length, setRC_length] = useState([]);
    const [dsr_length, setDSR_Lenght] = useState([]);
    const [dsc_length, setDSC_Lenght] = useState([]);
    const [languages_length, setLanguages_Lenght] = useState([]);

    const fetchUsers = async () => {
        const resp = await usersApi.get_users_list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setUser_Length(resp.rows.length);
    }

    const fetchSubscribers = async () => {
        const resp = await subscribersService.s_list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        setSubscribers_Length(resp.rows.length);
    }

    const fetchNewsCategory = async () => {
        const resp = await newsCategories.nc_list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setNC_Length(resp.rows.length);
    }

    const fetchNewsRecords = async () => {
        const resp = await newsRecords.nr_list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setNR_Length(resp.rows.length);
    }

    const fetchAboutUsCategory = async () => {
        const resp = await AboutUsCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIAC_Lenght(resp.rows.length);
    }

    const fetchAboutUsRecords = async () => {
        const resp = await AboutUsPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIAR_Lenght(resp.rows.length);
    }

    const fetchVacanciesCategory = async () => {
        const resp = await VacancyCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setVC_Lenght(resp.rows.length);
    }

    const fetchVacanciesRecords = async () => {
        const resp = await VacancyPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setVR_Lenght(resp.rows.length);
    }

    const fetchTransportationCategory = async () => {
        const resp = await TransportationToOrderCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setTTOC_Lenght(resp.rows.length);
    }

    const fetchTransportationRecords = async () => {
        const resp = await TransportationToOrderPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setTTOR_Lenght(resp.rows.length);
    }

    const fetchRoadToAiroportCategory = async () => {
        const resp = await RoadToAirportCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setRTAC_Lenght(resp.rows.length);
    }

    const fetchRoadToAiroportRecords = async () => {
        const resp = await RoadToAirportPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setRTAR_Lenght(resp.rows.length);
    }

    const fetchInformationForTouristsCategory = async () => {
        const resp = await InformationForTouristsCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIFTC_Lenght(resp.rows.length);
    }

    const fetchInformationForTouristsRecords = async () => {
        const resp = await InformationForTouristsPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIFTR_Lenght(resp.rows.length);
    }

    const fetchInternationalProjectCategory = async () => {
        const resp = await InternationalProjectsCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIPC_Lenght(resp.rows.length);
    }

    const fetchInternationalProjectRecords = async () => {
        const resp = await InternationalProjectsPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setIPR_Lenght(resp.rows.length);
    }

    const fetchElectricitySupplyCategory = async () => {
        const resp = await ElectricitySupplyCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setESC_Lenght(resp.rows.length);
    }

    const fetchElectricitySupplyRecords = async () => {
        const resp = await ElectricitySupplyPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setESR_Lenght(resp.rows.length);
    }

    const fetchRoadSituationCategory = async () => {
        const resp = await RoadSituationCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setRSC_Lenght(resp.rows.length);
    }

    const fetchRoadSituationRecords = async () => {
        const resp = await RoadSituationPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setRSR_Lenght(resp.rows.length);
    }

    const fetchTicketsCategory = async () => {
        const resp = await TicketsCategories.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setTC_length(resp.rows.length);
    }

    const fetchTicketsRecords = async () => {
        const resp = await TicketsPosts.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setRC_length(resp.rows.length);
    }

    const fetchDriverSchoolList = async () => {
        const resp = await driversSchoolApi.getDsList({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setDSR_Lenght(resp.rows.length);
    }

    const fetchDriverSchoolCategoriesList = async () => {
        const resp = await driversSchoolCategoriesApi.list({'page' : 1, 'per_page' : 0});
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setDSC_Lenght(resp.rows.length);
    }

    const fetchLanguageList = async () => {
        const resp = await apiLanguageMethodService.getLanguageList();
        if (resp) setLoading(false);
        if (typeof (resp.rows) !== 'undefined') setLanguages_Lenght(resp.rows.length);
    }

    useEffect(() => {
        fetchUsers()
        fetchSubscribers()
        fetchNewsCategory()
        fetchNewsRecords()
        fetchAboutUsCategory()
        fetchAboutUsRecords()
        fetchVacanciesCategory()
        fetchVacanciesRecords()
        fetchTransportationRecords()
        fetchTransportationCategory()
        fetchRoadToAiroportCategory()
        fetchRoadToAiroportRecords()
        fetchInformationForTouristsCategory()
        fetchInformationForTouristsRecords()
        fetchInternationalProjectCategory()
        fetchInternationalProjectRecords()
        fetchElectricitySupplyCategory()
        fetchElectricitySupplyRecords()
        fetchRoadSituationCategory()
        fetchRoadSituationRecords()
        fetchTicketsCategory()
        fetchTicketsRecords()
        fetchDriverSchoolList()
        fetchDriverSchoolCategoriesList()
        fetchLanguageList()
    }, [])

    const dataList = [
        { name: getStaticText('nav_users'), value: users_length },
        { name: getStaticText('s_nav_title'), value: subscribers_length },
        {
            name: getStaticText('news_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: nc_length },
                { title: getStaticText('about_items_orders'), value: nr_length },
            ]
        },
        {
            name: getStaticText('about_us_information'),
            subName: [
                { title: getStaticText('about_items_category'), value: iac_length },
                { title: getStaticText('about_items_orders'), value: iar_length },
            ]
        },
        {
            name: getStaticText('vacancies'),
            subName: [
                { title: getStaticText('about_items_category'), value: vc_length },
                { title: getStaticText('about_items_orders'), value: vr_length },
            ]
        },
        {
            name: getStaticText('transportation_to_order'),
            subName: [
                { title: getStaticText('about_items_category'), value: ttoc_length },
                { title: getStaticText('about_items_orders'), value: ttor_length },
            ]
        },
        {
            name: getStaticText('rta_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: rtac_length },
                { title: getStaticText('about_items_orders'), value: rtar_length },
            ]
        },
        {
            name: getStaticText('ift_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: iftc_length },
                { title: getStaticText('about_items_orders'), value: iftr_length },
            ]
        },
        {
            name: getStaticText('ip_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: ipc_length },
                { title: getStaticText('about_items_orders'), value: ipr_length },
            ]
        },
        {
            name: getStaticText('es_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: esc_length },
                { title: getStaticText('about_items_orders'), value: esr_length },
            ]
        },
        {
            name: getStaticText('rs_nav_title'),
            subName: [
                { title: getStaticText('about_items_category'), value: rsc_length },
                { title: getStaticText('about_items_orders'), value: rsr_length },
            ]
        },
        {
            name: getStaticText('nav_ticket'),
            subName: [
                { title: getStaticText('about_items_category'), value: tc_length },
                { title: getStaticText('about_items_orders'), value: tr_length },
            ]
        },
        {
            name: getStaticText('ds_nav_title'),
            subName: [
                { title: getStaticText('ds_nav_category_title'), value: dsc_length },
                { title: getStaticText('ds_nav_records_title'), value: dsr_length },
            ]
        },
        { name: getStaticText('settings_lng'), value: languages_length },

    ]

    return (
        <>
            {
                loading ? <div className='text-center'>< Spinner /></div > :
                    <DashboardWrapper>
                        <DashboardWrapperMain>
                            <div className='d-flex flex-wrap'>
                                {dataList.map((data, idx) => (
                                    <div key={idx}>
                                        <PageCard data={data} />
                                    </div>
                                ))}
                            </div>
                        </DashboardWrapperMain>
                    </DashboardWrapper>
            }
        </>


    )
}

export default Dashboard;
